import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { FlashService } from '@app/services/flash.service';
import { Brand } from '@app/models/brand';
import { BrandService } from '@app/services/api/brand.service';
import { ApiService } from '@app/services/api/api.service';
import { Router } from '@angular/router';
import {
  LoadFail,
  LoadSuccess,
  BrandActionTypes,
  Create,
  CreateFail,
  CreateSuccess,
  AddOne,
  AddPicture,
  UpdateBrand,
  UpdateBrandOne,
  UpdateBrandSuccess,
  UpdateFail
} from '@core/actions/brand.actions';

@Injectable()
export class BrandEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType(BrandActionTypes.Load),
    switchMap(() =>
      this.api.getBrands().pipe(
        map((brands: Brand[]) => new LoadSuccess(brands)),
        catchError(error => of(new LoadFail(error)))
      )
    )
  );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(BrandActionTypes.Create),
    map(action => action.brand),
    switchMap(brand =>
      this.brandsApi.create(brand).pipe(
        map((savedBrand: Brand) => new CreateSuccess(savedBrand)),
        catchError(error => of(new CreateFail(error)))
      )
    )
  );

  @Effect()
  createSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<CreateSuccess>(BrandActionTypes.CreateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Marca creada' });
      return new AddOne(action.brand);
    })
  );

  @Effect()
  update$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateBrand>(BrandActionTypes.UpdateBrand),
    map(action => [action.id, action.brand]),
    switchMap(([id, data]) => {
      return this.brandsApi.update(id, data).pipe(
        map((brands: Brand) => new UpdateBrandSuccess(id, brands)),
        catchError(error => of(new UpdateFail(error)))
      );
    })
  );

  @Effect()
  updateSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateBrandSuccess>(BrandActionTypes.UpdateBrandSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Marca actualizada' });
      return new UpdateBrandOne(action.data);
    })
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private brandsApi: BrandService,
    private fs: FlashService,
    private router: Router
  ) {}
}
